import { Routes } from '@angular/router';

export const addinRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./schedule-visitor/schedule-visitor.component').then(m => m.ScheduleVisitorComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
